import type {
  RequirementType,
  RequirementPriorityLevel,
  RequirementStatus,
  RequirementColumn,
} from '@ispot/shared'
export {
  REQUIREMENT_TYPE_BY_DEPTH,
  getAllowedRequirementTypesAtDepth,
  getAllowedRequirementTypesForParent,
} from '@ispot/shared'

export const DEFAULT_VISIBLE_REQUIREMENT_COLUMNS: Record<RequirementColumn, boolean> = {
  description: true,
  type: true,
  priority: true,
  status: true,
  assignee: true,
  evidence: true,
  themes: true,
  personas: true,
  completeness: true,
}

export const REQUIREMENT_STATUS_LABELS: Record<RequirementStatus, string> = {
  backlog: 'Backlog',
  planned: 'Planned',
  'in-progress': 'In Progress',
  'in-review': 'In Review',
  done: 'Done',
}

export const REQUIREMENT_PRIORITY_LABELS: Record<RequirementPriorityLevel, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
}

export const REQUIREMENT_TYPE_LABELS: Record<RequirementType, string> = {
  epic: 'Epic',
  story: 'Story',
  'nfr-category': 'NFR Category',
}
